module.exports = __webpack_public_path__ + "static/media/087.f2135934.jpg";